var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"toolbar",attrs:{"elevation":"0","dense":""}},[_c('v-toolbar-title',[_c('h4',[_vm._v("Guias de faturamento")])]),_c('v-spacer'),_c('div',{staticClass:"mr-2"},[_c('conciliacao-faturamento-guias-sort')],1),_c('conciliacao-faturamento-guias-filter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }